const FSA = function (type, payload, meta) {
    return Object.assign({}, {type, payload, error: payload instanceof Error, meta})
};

export default FSA;
